import { Pipe, PipeTransform, inject } from "@angular/core";
import { I18nService } from "../../core/i18n";

@Pipe({
    name: 'compactstring',
    standalone: false
})
export class CompactStringPipe implements PipeTransform {
	transform(val: string) {
        if (!val) return "";
        return val.replace(/\s\s+/g, ' '); 
	}
}

@Pipe({
    name: 'ticketSource'
})
export class TicketSourcePipe implements PipeTransform {
	private i18n = inject(I18nService);
	transform(val: number) {
                if ((!val) || (val > 4) ) return "";

                var lookup = [this.i18n.t('common.email', 'Email'), this.i18n.t('inbox.pipes.compactstring.chat', 'Chat'), this.i18n.t('inbox.pipes.compactstring.agent', 'Agent')];
                
                return lookup[val - 1];
	}
}